// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_d9-b";
export var colorBlue = "_d9-8";
export var colorDot = "_d9-0";
export var colorDotLarge = "_d9-2";
export var colorDotSmall = "_d9-1";
export var colorGreen = "_d9-7";
export var colorGrey = "_d9-3";
export var colorOrange = "_d9-5";
export var colorPink = "_d9-a";
export var colorPurple = "_d9-9";
export var colorRed = "_d9-4";
export var colorYellow = "_d9-6";